










































import { Component, Vue, Watch } from "vue-property-decorator";
import AsideMenu from "@/components/layout/AsideMenu.vue";
import Dashboard from "@/views/Dashboard.vue";
import AddModal from "@/components/nueces/AddModal.vue";
import AddCamionModal from "@/components/catalogs/AddCamionModal.vue";
import AddPersonaModal from "@/components/personas/AddPersonaModal.vue";
import { mapGetters } from "vuex";

@Component({
  components: {
    AsideMenu,
    Dashboard,
    AddModal,
    AddPersonaModal,
    AddCamionModal
  },
  computed: {
    ...mapGetters("UserModule", {
      activeStorage: "getStorage"
    }),
    ...mapGetters("TransportModule", {
      companies: "getCompanies"
    })
  }
})
export default class Layout extends Vue {
  modalNuecesOpen = false;
  modalProductorOpen = false;
  modalCamionOpen = false;
  closeModal(type: string) {
    this.$store.dispatch(type, false);
  }

  get routeName() {
    return this.$route.name;
  }
  get sidebarState(): boolean {
    return this.$store.state.sidebarOpen;
  }

  @Watch("$store.state.modalNuecesOpen")
  setValNueces(val: boolean): void {
    this.modalNuecesOpen = val;
  }

  @Watch("$store.state.modalProductorOpen")
  setValProductor(val: boolean): void {
    this.modalProductorOpen = val;
  }

  @Watch("$store.state.modalCamionOpen")
  setValCamion(val: boolean): void {
    this.modalCamionOpen = val;
  }
}
